export const seguroTotal = {
  titulo: "Seguro total",
  descricao:
    "A cobertura compreensiva, também conhecida como seguro total, é uma opção mais abrangente de seguro para automóveis. Ela oferece proteção contra uma ampla gama de eventos, incluindo colisões, roubo, incêndio, danos causados por fenômenos naturais (como enchentes e queda de árvores), entre outros. Além disso, o segurado poderá incluir cobertura para danos causados a terceiros, como danos materiais e corporais. Essa cobertura é ideal para quem busca uma proteção mais completa e está disposto a pagar um valor um pouco mais alto.",
};

export const danosMateriais = {
  titulo: "Danos materiais",
  descricao:
    "Cobertura dos danos causados aos bens de terceiros, seja um carro, moto, bicicleta ou até mesmo os danos causados pela batida em um poste de eletricidade, no muro de uma casa ou na fachada de uma loja.",
};

export const danosCorporais = {
  titulo: "Danos corporais",
  descricao:
    "Caso o segurado se envolva em um acidente com seu carro e seja o culpado/responsabilizado civilmente pelo ferimento ou morte de um terceiro, essa cobertura garante a indenização dos gastos que essa pessoa venha a ter com serviços hospitalares ou, caso ocorra o falecimento, cobre as despesas funerárias dos familiares da vítima.",
};

export const danosMorais = {
  titulo: "Danos morais",
  descricao:
    "Garante ao segurado, até o limite máximo de indenização contratado, indenização por danos morais causados a terceiros pelos quais o segurado venha a ser responsabilizado civilmente em decisão ou acordo judicial.​",
};

export const assistencia = {
  titulo: "Assistência 24h",
  descricao:
    "A assistência é um serviço de suporte ao segurado em situações de emergência ou imprevistos relacionados ao veículo.",
};

export const vidros = {
  titulo: "Assistência de vidros",
  descricao:
    "A cobertura de vidro é uma assistência específica para reparo ou substituição de vidros, faróis, retrovisores e outros itens de vidro do veículo. Geralmente, essa cobertura possui uma franquia específica para cada item, ou seja, o segurado precisa pagar uma parte do valor do reparo ou substituição do vidro, enquanto a seguradora cobre o restante.",
};

export const invalidezEMorte = {
  titulo: "APP - Invalidez e morte",
  descricao:
    "Tratando-se de acidentes pessoais com os passageiros do veículo segurado, a seguradora indenizará, em caso de falecimento, os herdeiros legais e, em caso de invalidez permanente, os próprios passageiros, respeitados os critérios quanto à lotação oficial do veículo.",
};

export const carroReserva = {
  titulo: "Carro reserva",
  descricao:
    "Em caso de sinistro que deixe o veículo segurado indisponível para uso, a cobertura de carro reserva oferece a disponibilização de um veículo substituto para o segurado utilizar durante o período de reparo do seu veículo. O número de dias para disponibilização do carro reserva varia de acordo com a apólice e a seguradora, podendo ser de alguns dias até um período mais longo, dependendo das condições contratadas.",
};
